import { 
  LayoutDashboard, 
  TrendingUp, 
  Phone, 
  Mail, 
  PhoneCall,
  MessageSquare,
  FolderOpen,
  Image,
  Images,
  FileText,
  Wrench,
  MapPin,
  Star,
  Globe,
  Tags,
  Users,
  Calendar,
  DollarSign
} from "lucide-react";
import { NavLink } from "react-router-dom";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar";

const navigationGroups = [
  {
    label: "Dashboard",
    items: [
      { title: "Overview", url: "/admin", icon: LayoutDashboard, end: true },
      { title: "Analytics", url: "/admin/analytics", icon: TrendingUp },
      { title: "Call Tracking", url: "/admin/calls", icon: Phone },
    ]
  },
  {
    label: "Sales & Estimates",
    items: [
      { title: "All Leads", url: "/admin/all-leads", icon: Users },
      { title: "Customers", url: "/admin/customers", icon: Users },
      { title: "Appointments", url: "/admin/appointments", icon: Calendar },
      { title: "Estimates", url: "/admin/estimates", icon: FileText },
      { title: "Change Requests", url: "/admin/change-requests", icon: MessageSquare },
      { title: "Proposal Gallery", url: "/admin/proposal-gallery", icon: Images },
      { title: "Phone Leads", url: "/admin/phone-leads", icon: PhoneCall },
      { title: "Contact Leads", url: "/admin/leads", icon: Mail },
      { title: "SMS Messages", url: "/admin/sms-phone-numbers", icon: MessageSquare },
    ]
  },
  {
    label: "Website Content",
    items: [
      { title: "Projects Gallery", url: "/admin/projects", icon: FolderOpen },
      { title: "Project Categories", url: "/admin/categories", icon: Tags },
      { title: "Services", url: "/admin/services", icon: Wrench },
      { title: "Featured Projects", url: "/admin/featured-content", icon: Star },
      { title: "Page Assignments", url: "/admin/page-projects", icon: FileText },
    ]
  },
  {
    label: "Pricing",
    items: [
      { title: "Price Book", url: "/admin/price-book", icon: DollarSign },
    ]
  },
  {
    label: "Settings",
    items: [
      { title: "City Groups", url: "/admin/city-groups", icon: MapPin },
      { title: "SMS Settings", url: "/admin/sms-settings", icon: MessageSquare },
      { title: "General", url: "/admin/settings", icon: Globe },
    ]
  },
];

export function AdminSidebar() {
  const { open } = useSidebar();

  return (
    <Sidebar collapsible="icon" className={open ? "w-60" : "w-14"}>
      <SidebarContent>
        {navigationGroups.map((group) => (
          <SidebarGroup key={group.label}>
            <SidebarGroupLabel>{group.label}</SidebarGroupLabel>
            <SidebarGroupContent>
              <SidebarMenu>
                {group.items.map((item) => (
                  <SidebarMenuItem key={item.title}>
                    <SidebarMenuButton asChild>
                      <NavLink 
                        to={item.url} 
                        end={item.end}
                        className={({ isActive }) => 
                          isActive ? "bg-accent text-accent-foreground" : ""
                        }
                      >
                        <item.icon className="h-4 w-4" />
                        {open && <span>{item.title}</span>}
                      </NavLink>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                ))}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        ))}
      </SidebarContent>
    </Sidebar>
  );
}
